import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import Button from '@/components/UI/Button/Button';
import authUtils from '@/helpers/authUtils';
import { STORAGE } from '@/helpers/constants';
import useAppLanguage from '@/hooks/useAppLanguage';
import titleService from '@/services/titleService';
import styles from './Login.module.scss';

const Login = () => {
  const { t } = useTranslation();
  const lang = useAppLanguage();
  const auth = useAuth();

  useEffect(() => {
    titleService.updatePageTitle(t('login'));
  }, [t, lang]);

  const redirectLogin = useCallback(() => {
    sessionStorage.setItem(STORAGE.LAST_ACTION_WAS_LOGIN, '1');
    auth.signinRedirect().catch(console.error);
  }, [auth]);

  const register = () => window.open(authUtils.registerUrl, '_blank');

  return (
    <div className={styles.Login}>
      <section className={styles.BG}>
        <section className={styles.Block}>
          <h1 className={styles.Title}>{t('welcome.title')}</h1>
          <p>{t('welcome.message')}</p>
          <div className={styles.ButtonLine}>
            <Button id="register" buttonStyle="Outlined" btnText={t('register')} handleClick={register} />
            <Button id="login" buttonStyle="Primary" btnText={t('login')} handleClick={redirectLogin} />
          </div>
        </section>
      </section>
      <section className={styles.Content}>
        <section className={styles.Block}>
          <h2>{t('welcome.generalInfo')}</h2>
          <p>{t('welcome.generalInfo1')}</p>
          <p>{t('welcome.generalInfo2')}</p>
          <p>{t('welcome.generalInfo3')}</p>
          <div className={styles.Links}>
            <section className={styles.LinksBlock}>
              <h3>{t('welcome.infoSupport')}</h3>
              <ul>
                <li>
                  <a href="https://social.intra.corpintra.net/groups/cart" target="_blank" rel="noopener noreferrer">
                    CaRT Community
                  </a>
                </li>
              </ul>
            </section>
            <section className={styles.LinksBlock}>
              <h3>{t('welcome.relatedServices')}</h3>
              <ul>
                <li>
                  <a href="https://social.intra.corpintra.net/groups/intakt" target="_blank" rel="noopener noreferrer">
                    INTAKT Community
                  </a>
                </li>
                <li>
                  <a href="https://social.intra.corpintra.net/groups/zasm" target="_blank" rel="noopener noreferrer">
                    ZASM Community
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Login;
